import React, { useState } from "react";

import BannerHelloEMS2 from "../images/Advantages of (4).png";

import BannerClotaRx from "../images/ClotaRximg.png"

import { useNavigate } from "react-router-dom";

import homeB9 from "../images/Homebanner1.png";

import missionAndVission from "../../new_Images/Home Page/Selected One.jpg";

import { IoLocationOutline, IoShieldCheckmarkSharp } from "react-icons/io5";

import { SlCalender } from "react-icons/sl";

import { SlOrganization } from "react-icons/sl";

import { FaUsers } from "react-icons/fa";

import { MdAccessTime, MdOutlineAnalytics, MdOutlineCalendarMonth, MdOutlineMedicalServices, MdOutlinePayments, MdOutlinePeopleAlt, MdOutlineWhatsapp } from "react-icons/md";

import { GiReceiveMoney } from "react-icons/gi";

import WebDevelopmentimG from "../images/development.png";

import databaseimg1N from "../../new_Images/Home Page/database.png";

import cloudimg from "../../new_Images/Home Page/cloud.jpg";

import AdditionalimG from "../images/ADDITIONAL SERVICE.png";

import CommanComponentContact from "./CommanComponentContact";
import { Helmet } from "react-helmet";
import { Button } from "primereact/button";

import TestimonialSlider from "./testimonial";

function Home() {
  const navigate = useNavigate();

  const [activelink, setActivelink] = useState("link1");

  const [component1, setComponent1] = useState(true);

  const [component2, setComponent2] = useState(false);

  const [component3, setComponent3] = useState(false);

  const [component4, setComponent4] = useState(false);

  const handleClick = (link) => {
    setActivelink(link);

    setComponent1(link === "link1");

    setComponent2(link === "link2");

    setComponent3(link === "link3");

    setComponent4(link === "link4");
  };

  function ComponentOne(props) {
    return (
      <div
        className="costom-clota-card"
        style={{ display: props.isVisible ? "block" : "none" }}>
        <div className="homeServicesParent ">
          <div className="homeServicesText m-5">
            <i>
              <p>
                Clota Technology design and construct websites that are
                effective business channels that interact with the target
                audience, using elegant aesthetics and out-of-the-box design
                concepts. Our websites are simple, straightforward and tailored
                to particular requirements.
              </p>
            </i>

            <Button
              type="button"
              className="btn-styles btn btn-info"
              onClick={() => {
                navigate(`/WebDevelopment`);

                scrollToTop();
              }}
              style={{ width: "155px" }}>
              More Details
            </Button>
          </div>

          <div className="homeServicesImg  p-col-12 p-md-6 p-lg-5">
            <img
              src={WebDevelopmentimG}
              alt="Descriptionofimage"
              className="img-fluid"
              width="250px"
            />
          </div>
        </div>
      </div>
    );
  }

  function ComponentTwo(props) {
    return (
      <div
        className="costom-clota-card"
        style={{ display: props.isVisible ? "block" : "none" }}>
        <div className="homeServicesParent">
          <div className="homeServicesText m-5">
            <i>
              <p>
                Database Services protects and monitors customer databases by
                establishing backup and recovery procedures, providing a secure
                database environment and monitoring database performance.
              </p>
            </i>

            <Button
              type="button"
              className="btn-styles btn btn-info"
              onClick={() => {
                navigate(`/DatabaseServices`);

                scrollToTop();
              }}
              style={{ width: "165px" }}>
              More Details
            </Button>
          </div>

          <div className="homeServicesImg  p-col-12 p-md-6 p-lg-5">
            <img
              src={databaseimg1N}
              alt="Descriptionofimage"
              className="img-fluid mt-4"
              width="500px"
            />
          </div>
        </div>
      </div>
    );
  }

  function ComponentThree(props) {
    return (
      <div
        className="costom-clota-card"
        style={{ display: props.isVisible ? "block" : "none" }}>
        <div className="homeServicesParent">
          <div className="homeServicesText m-5">
            <i>
              <p>
                Cloud services, hosted by third-party providers and accessed via
                the internet, enable cloud-native applications and flexible
                work. Our web development team creates tailored websites and
                applications. Businesses no longer need to purchase and manage
                hardware, reducing costs and complexity.
              </p>
            </i>

            <Button
              type="button"
              className="btn-styles btn btn-info"
              onClick={() => {
                navigate(`/CloudServices`);

                scrollToTop();
              }}
              style={{ width: "165px" }}>
              More Details
            </Button>
          </div>

          <div className="homeServicesImg  p-col-12 p-md-6 p-lg-5">
            <img
              src={cloudimg}
              alt="Descriptionofimage"
              className="img-fluid cloud-srvcs"
            />
          </div>
        </div>

        {/* </div> */}
      </div>
    );
  }

  function ComponentFour(props) {
    return (
      <div
        className="costom-clota-card"
        style={{ display: props.isVisible ? "block" : "none" }}>
        <div className="homeServicesParent">
          <div className="homeServicesText m-5">
            <i>
              <p>
                Software tools optimize business processes, document
                development, and improve project productivity. Our software tool
                development approach focuses on meeting company expectations,
                tool effectiveness, integration, choosing the right environment,
                and minimizing the learning curve.
              </p>
            </i>

            <Button
              type="button"
              className="btn-styles btn btn-info"
              onClick={() => {
                navigate(`/AdditionalServices`);

                scrollToTop();
              }}
              style={{ width: "165px" }}>
              More Details
            </Button>
          </div>

          <div className="homeServicesImg  p-col-12 p-md-6 p-lg-5">
            <img
              src={AdditionalimG}
              alt="Descriptionofimage"
              className="img-fluid"
              width="450px"
            />
          </div>
        </div>
      </div>
    );
  }

  function ComponentOneClotaRx(props) {
    return (
      <div
        className="costom-clota-card"
        style={{ display: props.isVisible ? "block" : "none" }}>
        <div className="homeServicesParent">
          <div className="homeServicesText m-5">
            <i>
              <p>
              HelloEMS is a comprehensive Employee Management System that simplifies HR 
              processes and enhances employee management. Manage attendance, leaves, shifts,
               payroll, and organizational data from a single platform
              </p>
            </i>

            <Button
  type="button"
  className="btn-styles btn btn-info"
  onClick={() => {
    window.open("https://helloems.com/", "_blank");
  }}
  style={{ width: "165px" }}
>
  More Details
</Button>
          </div>

          <div className="homeServicesImg  p-col-12 p-md-6 p-lg-5">
            <img
              src={AdditionalimG}
              alt="Descriptionofimage"
              className="img-fluid"
              width="450px"
            />
          </div>
        </div>
      </div>
    );
  }

  function ComponentTwoClotaRx(props) {
    return (
      <div
        className="costom-clota-card"
        style={{ display: props.isVisible ? "block" : "none" }}>
        <div className="homeServicesParent">
          <div className="homeServicesText m-5">
            <i>
              <p>
              ClotaRx is a comprehensive Healthcare Management Platform designed 
              to simplify clinic operations and enhance patient care. From appointments 
              to billing, everything is managed seamlessly in one place.
              </p>
            </i>

            <Button
  type="button"
  className="btn-styles btn btn-info"
  onClick={() => {
    window.open("https://clotarx.com/", "_blank");
  }}
  style={{ width: "165px" }}
>
  More Details
</Button>
          </div>

          <div className="homeServicesImg  p-col-12 p-md-6 p-lg-5">
            <img
              src={AdditionalimG}
              alt="Descriptionofimage"
              className="img-fluid"
              width="450px"
            />
          </div>
        </div>
      </div>
    );
  }

  const [navbarOpen, setNavbarOpen] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    closeNavbar();
  };

  const closeNavbar = () => {
    setNavbarOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>Home | Clota Technology</title>
        <meta
          name="description"
          content="CLOTA Technology, we provide innovative solutions in database technologies, web development, cloud maintenance, and software support to help businesses achieve their goals"
        />
        <meta
          name="keywords"
          content="Clotatech, DatabaseServices, Best Web Development Services, Clota Technology, Payroll, Attendance, Shift Management"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Clota Technology" />
        <link rel="canonical" href="https://www.clotatech.com/" />
      </Helmet>

      <div>
        <div className="hero-banner">
          <img src={homeB9} className="hero-image" alt="Banner" />

          {/* Centered Content */}
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-heading">Clota Technology</h1>
              <p>
                BIG THOUGHTS, BIGGER ACTIONS
                <br />& GREATER RESULTS
              </p>
            </div>
          </div>
        </div>

        <div className="card-body">
          <br />

          <div
            className="text-center Text-Gradient"
            style={{ fontFamily: "rockwell" }}>
            <h1 className="m-5">
              <b>Simplify HR Operations With HelloEMS</b>
            </h1>
          </div>

          <p className="card-text text-center">
            <i>
              HelloEMS a comprehensive Employee Management System designed to
              streamline HR processes.
            </i>
          </p>

          <div
            className="text-center Text-Gradient"
            style={{ fontFamily: "rockwell", fontSize: "1.3rem" }}>
            <h2 className="mt-4">Our Features</h2>
          </div>

          {/* <h2 className="text-center Text-Gradient mt-4">Our Features</h2> */}

          <div className="helloEMSParent">
            <img src={BannerHelloEMS2} alt="" />

            <div className="features-points ml-5">
              <IoLocationOutline />

              <p className="mainFeatures ">Attendance</p>

              <SlCalender />

              <p>Leaves Management</p>

              <SlOrganization style={{ color: "tomato" }} />

              <p>Organization</p>
            </div>

            <div className="features-points ml-5">
              <FaUsers style={{ color: "palevioletred" }} />

              <p>Employees Management</p>

              <MdAccessTime style={{ color: "#e65100" }} />

              <p>Shift Management</p>

              <GiReceiveMoney style={{ color: "orange" }} />

              <p>Payroll Management</p>
            </div>
          </div>

          <div className="flex justify-content-center">
            <Button
              label="Visit Our Site"
              icon="pi pi-globe"
              className="btn-styles btn"
              style={{ width: "170px" }}
              onClick={() => window.open("https://helloems.com", "_blank")}
            />
          </div>
        </div>


        <div className="card-body">
          <br />

          {/* <h1
            className="Text-Gradient text-center"
            style={{ fontFamily: "rockwell" }}
          >
            <b>Looking For Best Employee Management System</b>
          </h1> */}

          <div
            className="text-center Text-Gradient"
            style={{ fontFamily: "rockwell" }}>
            <h1 className="m-5">
              <b>Manage Your Clinic Smarter With ClotaRx</b>
            </h1>
          </div>




          <p className="card-text text-center">
            <i>
            ClotaRx is an AI-powered healthcare platform that helps clinics
             manage patients, appointments, prescriptions, and billing with ease.
            </i>
          </p>

          <div
            className="text-center Text-Gradient"
            style={{ fontFamily: "rockwell", fontSize: "1.3rem" }}>
            <h2 className="mt-4">Our Features</h2>
          </div>

          
          <div className="helloEMSParent">
          <div className="features-points ml-5">
              <MdOutlineMedicalServices/>

              <p className="mainFeatures ">AI-Powered Digital Prescriptions</p>

              <MdOutlineCalendarMonth/>

              <p>Smart Appointment Management</p>

              <MdOutlinePeopleAlt style={{ color: "tomato" }} />

              <p>Patient Records Management</p>
            </div>

            <div className="features-points ml-5">
              <MdOutlineWhatsapp 
              // style={{ color: "palevioletred" }}
               />

              <p>WhatsApp Communication</p>

              < MdOutlinePayments
              style={{ color: "#e65100" }}
               />

              <p>Billing & Revenue Tracking</p>

              <MdOutlineAnalytics style={{ color: "orange" }} />

              <p>Analytics & Reporting</p>
            </div>


            <img src={BannerClotaRx} alt="" />
          </div>



          {/* <h2 className="text-center Text-Gradient mt-4">Our Features</h2> */}

          <div className="flex justify-content-center">
            <Button
              label="Visit Our Site"
              icon="pi pi-globe"
              className="btn-styles btn"
              style={{ width: "170px" }}
              onClick={() => window.open("https://clotarx.com/", "_blank")}
            />
          </div>
        </div>
        <div className="mt-5 px-5 py-2">
          <div className="grid p-fluid">
            {/* Left Column */}
            <div className="col-12 md:col-6 flex align-items-center">
              <div>
                {/* <h1
                  className="Text-Gradient"
                  style={{ fontFamily: "rockwell" }}
                >
                  <b>Why Clota?</b>
                </h1> */}
                <div
                  className="text-left Text-Gradient"
                  style={{ fontFamily: "rockwell" }}>
                  <h1 className="">
                    <b> Why Clota?</b>
                  </h1>
                </div>

                <p>
                  <i>
                    Your one-stop shop for digital solutions and marketing,
                    known for creativity, transparency, and strong work ethics.
                  </i>
                </p>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-12 md:col-6">
              <div className="mb-4">
                <h5
                  className="flex align-items-center"
                  style={{ fontFamily: "rockwell" }}>
                  <IoShieldCheckmarkSharp className="mr-2 missionVisionBanner-icon" />
                  <b>
                    <i>Clota Technology Follow Proven Processes</i>
                  </b>
                </h5>
                <p className="ml-4">
                  <i>
                    Clota Technology craft strategies to grow your business
                    through innovative web designs, apps and marketing
                    campaigns, positioning your brand for success.
                  </i>
                </p>
              </div>

              <div className="mb-4">
                <h5
                  className="flex align-items-center"
                  style={{ fontFamily: "rockwell" }}>
                  <IoShieldCheckmarkSharp className="mr-2 missionVisionBanner-icon" />
                  <b>
                    <i>Research And Support</i>
                  </b>
                </h5>
                <p className="ml-4">
                  <i>
                    Clota Technology deliver top-quality solutions with a simple
                    process and are always available for our clients, making us
                    the best choice.
                  </i>
                </p>
              </div>

              <div>
                <h5
                  className="flex align-items-center"
                  style={{ fontFamily: "rockwell" }}>
                  <IoShieldCheckmarkSharp className="mr-2 missionVisionBanner-icon" />
                  <b>
                    <i>
                      Clota Technology Focus On How It Will Profit Your Business
                    </i>
                  </b>
                </h5>
                <p className="ml-4">
                  <i>
                    Clota Technology focus on customer needs, developing
                    strategies that attract and convert new customers, helping
                    brands make a strong impact and increase revenue.
                  </i>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Mission image with title  */}
        <div className="missionVisionBanner mt-5 px-5 py-2">
          <img src={missionAndVission} className="" alt="Descriptionofimage" />
        </div>
        {/* Text Vision */}
        <div className="">
          <div
            className="mt-5 px-5 py-2 Text-Gradient"
            style={{ fontFamily: "rockwell" }}>
            <h1>
              <b> Services</b>
            </h1>
          </div>

          <div className="area">
            <div
              className={`area-left ${
                activelink === "link1" ? "active-link-css" : ""
              }`}
              onClick={() => handleClick("link1")}>
              Web Development
            </div>

            <div
              className={`area-right ${
                activelink === "link2" ? "active-link-css" : ""
              }`}
              onClick={() => handleClick("link2")}>
              Database Services
            </div>

            <div
              className={`area-left ${
                activelink === "link3" ? "active-link-css" : ""
              }`}
              onClick={() => handleClick("link3")}>
              Cloud Services
            </div>

            <div
              className={`area-right ${
                activelink === "link4" ? "active-link-css" : ""
              }`}
              onClick={() => handleClick("link4")}>
              Additional Services
            </div>
          </div>

          <div className="main-section">
            <ComponentOne isVisible={component1} />

            <ComponentTwo isVisible={component2} />

            <ComponentThree isVisible={component3} />

            <ComponentFour isVisible={component4} />
          </div>
        </div>

        {/* <div className="">
          <div
            className="mt-5 px-5 py-2 Text-Gradient"
            style={{ fontFamily: "rockwell" }}>
            <h1>
              <b> Our Products</b>
            </h1>
          </div>

          <div className="area">
            <div
              className={`area-left ${
                activelink === "link1" ? "active-link-css" : ""
              }`}
              onClick={() => handleClick("link1")}>
              HRMS Solutions
            </div>

            <div
              className={`area-right ${
                activelink === "link2" ? "active-link-css" : ""
              }`}
              onClick={() => handleClick("link2")}>
              ClotaRx
            </div>

          </div>

          <div className="main-section">
            <ComponentOneClotaRx isVisible={component1} />

            <ComponentTwoClotaRx isVisible={component2} />

          </div>
        </div> */}

        <div className="">
          <TestimonialSlider />
        </div>
        <div className="px-5 py-2">
          <CommanComponentContact />
        </div>
      </div>
    </>
  );
}

export default Home;
